module.exports = __webpack_public_path__ + "img/ss5.9670a932.jpg";